export default {
  translatedStringLoading: [], // `{sourceLanguage}-{sourceText}`
  translatedStrings: {}, // [{ [`{sourceLanguage}-{sourceText}`]: { [`targetLanguage`]: `{targetText}` } }]
}
